export class ResolveChatModel {
  constructor(clientId: number) {
    this.clientId = clientId;
    this.resolutionReason = 0;
  }

  public clientId: number;
  public resolutionReason: number;
}
